/**
 * Eval & Orders list ordering (including Admission Documents):
 * Schedule Date ascending (oldest → newest).
 *
 * Schedule Date = form top-header Date (scheduleDate). Visit date is only a
 * fallback when the header date was never saved.
 */

const dayKey = (value) => {
  if (!value) return "";
  const s = String(value);
  const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (iso) return iso[1];
  const mdy = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (mdy) return `${mdy[3]}-${mdy[1]}-${mdy[2]}`;
  const t = Date.parse(s);
  if (!Number.isNaN(t)) return new Date(t).toISOString().slice(0, 10);
  return s;
};

/** Header Date first; calendar visit only if header date was never saved. */
export const clinicalFormScheduleDate = (form) =>
  form?.scheduleDate ||
  form?.serviceDate ||
  form?.scheduledVisit?.visitDate ||
  form?.visitDate ||
  "";

export const sortClinicalFormsByScheduleDateAsc = (forms) => {
  if (!Array.isArray(forms) || forms.length < 2) return forms || [];
  return [...forms].sort((a, b) => {
    const aVisit = dayKey(clinicalFormScheduleDate(a));
    const bVisit = dayKey(clinicalFormScheduleDate(b));

    if (aVisit && bVisit) {
      const byVisit = aVisit.localeCompare(bVisit);
      if (byVisit !== 0) return byVisit;
      return (a.id || 0) - (b.id || 0);
    }
    if (aVisit && !bVisit) return -1;
    if (!aVisit && bVisit) return 1;
    return (
      dayKey(a.createdAt).localeCompare(dayKey(b.createdAt)) ||
      (a.id || 0) - (b.id || 0)
    );
  });
};
